export default __webpack_public_path__ + "static/media/ic_qr_code.315ca32e.png";